import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function TemplateMarkupLayer({ enabled }) {
  const [patch, setPatch] = useState(null);
  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    fetch(`${API_URL}/api/public/template-markup`)
      .then((response) => response.ok ? response.json() : null)
      .then((data) => { if (active) setPatch(data?.patch || null); })
      .catch(() => undefined);
    return () => { active = false; };
  }, [enabled]);

  useEffect(() => {
    if (!patch) return undefined;
    const originals = [];
    const objectUrls = [];
    (patch.operations || []).forEach((operation) => {
      const node = operation.selector ? document.querySelector(operation.selector) : null;
      if (!node) return;
      if (operation.type === "text" && operation.value) {
        originals.push({ node, value: node.textContent, type: "text" });
        node.textContent = operation.value;
      }
      if (operation.type === "image" && operation.attachmentId) {
        const image = node.matches("img") ? node : node.querySelector("img");
        if (!image) return;
        fetch(`${API_URL}/api/public/template-markup/assets/${operation.attachmentId}`)
          .then((response) => response.ok ? response.blob() : null)
          .then((blob) => {
            if (!blob) return;
            const url = URL.createObjectURL(blob);
            objectUrls.push(url);
            originals.push({ node: image, value: image.src, type: "src" });
            image.src = url;
          })
          .catch(() => undefined);
      }
    });
    return () => {
      originals.forEach((item) => { if (item.type === "src") item.node.src = item.value; else item.node.textContent = item.value; });
      objectUrls.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [patch]);

  if (!patch) return null;
  return <style data-testid="published-template-markup-style">{String(patch.css || "").replaceAll(".markup-canvas ", "")}</style>;
}
